export default async (res) => {
    if (res.status === 200) {
        return res.json()
    } else if(res.status === 440){
        return res.json();
    } else {
        const errorMessage = await res.text();
        
        const error = {
            status: 'error',
            message: errorMessage
        }

        return error;
    }
}